import propTypes from 'prop-types';
import React from 'react';

const Hero = ({caption, height, ratio, src}) => (
	<div className='Hero' style={{backgroundImage: `url(${src})`, maxHeight: height}}>
		<div className='Hero-content'>
			{caption &&
				<h2 dangerouslySetInnerHTML={{__html: caption}}/>
			}
		</div>
		<div className='Hero-ratio' style={{paddingTop: ratio}}/>
		<style jsx>
			{`
				.Hero {
					background-color: rgba(0, 0, 0, 0.65);
					background-position: 50%;
					background-repeat: no-repeat;
					background-size: cover;
					overflow: hidden;
					position: relative;
					display: block;
				}

				.Hero-ratio {
					display: block;
					padding-top: 33%;
					width: 100%;
					position: relative;
				}

				.Hero-content {
					padding: 0 15px;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translateY(-50%) translateX(-50%)
				}

				h2 {
					color: #fff;
					background-color: #000;
					text-align: center;
					padding: 10px 20px;
				}
			`}
		</style>
	</div>
);

Hero.propTypes = {
	caption: propTypes.string,
	height: propTypes.string,
	ratio: propTypes.string,
	src: propTypes.string.isRequired
};

export default Hero;



// WEBPACK FOOTER //
// components/hero.js